import { trackAmplitudeEvent } from '../analytics/CustomEvents'

export default function initLandingSurveyModal () {
  const modal = document.getElementById('vjs-landing-survey-modal')
  const otherReasonHereRadioBtn = document.getElementById('vjs-landing-survey-reason5')
  const otherReasonBuyingRadioBtn = document.getElementById('vjs-landing-survey-buying-reason6')
  if (!modal || !otherReasonHereRadioBtn || !otherReasonBuyingRadioBtn) return // modal won't be on page if user already answered
  otherReasonHereRadioBtn.addEventListener('change', () => {
    const textBox = document.getElementById('vjs-landing-survey-other-answer')
    if (textBox) textBox.classList.remove('hidden')
  })

  otherReasonBuyingRadioBtn.addEventListener('change', () => {
    const textBox = document.getElementById('vjs-landing-survey-buying-reason-other-answer')
    if (textBox) textBox.classList.remove('hidden')
  })

  if (!shownRecently()) {
    modal.classList.add('show')
    recordShown()
    // Think there's an issue with racing condition when trying to use the Amplitude custom impression
    // tracking we have with "modals" that load on page render
    // as noticed the numbers were way off with the VIP Modal
    // so doing this instead
    trackAmplitudeEvent('Landing Survey Modal Viewed')
  }
}

// localStorage (not sessionStorage) so closing the survey isn't undone by every
// new tab; the server stops rendering it once answered.
const shownStorageKey = 'landingSurveyShownAt'
const repromptAfterMs = 30 * 24 * 60 * 60 * 1000

function shownRecently () {
  try {
    const shownAt = Number(window.localStorage.getItem(shownStorageKey))
    return Boolean(shownAt) && (Date.now() - shownAt) < repromptAfterMs
  } catch {
    return false
  }
}

function recordShown () {
  try {
    window.localStorage.setItem(shownStorageKey, Date.now().toString())
  } catch {}
}
